import { useEffect } from 'react';

const AndroidAssetLinks = () => {
  const assetLinks = [{
    "relation": ["delegate_permission/common.handle_all_urls"],
    "target": {
      "namespace": "android_app",
      "package_name": "com.dotstudiopro.greenlight",
      "sha256_cert_fingerprints":
      ["FA:C6:17:45:DC:09:03:78:6F:B9:ED:E6:2A:96:2B:39:9F:73:48:F0:BB:6F:89:9B:83:32:66:75:91:03:3B:9C"]
    }
  }];

  useEffect(() => {
    // Set the content type to application/json
    document.querySelector('meta[name="content-type"]')?.setAttribute('content', 'application/json');
  }, []);

  // Return the JSON as a pre-formatted string
  return (
    <pre style={{ 
      fontFamily: 'monospace', 
      whiteSpace: 'pre-wrap', 
      margin: 0,
      padding: 0,
      backgroundColor: 'transparent',
      border: 'none'
    }}>
      {JSON.stringify(assetLinks, null, 2)}
    </pre>
  );
};

export default AndroidAssetLinks;

